import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import CreateAnnouncementListing from '@/modules/announcement/components/CreateAnnouncement/components/CreateAnnouncementListing'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function CreateAnnouncementPage() {
	return (
		<PageContainer>
			<CreateAnnouncementListing />
		</PageContainer>
	)
}

const GuardedCreateAnnouncementPage = withUserPermission(
	CreateAnnouncementPage,
	{
		permissionType: PermissionType.Write,
		permissionKey: [PermissionKeys.MANAGE_ANNOUNCEMENT],
	},
)

export default GuardedCreateAnnouncementPage
